import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2btq7m6dwd: FaireBrandEntity = {
  token: "b_2btq7m6dwd",
  type: "brand",
  name: "D&E Threads",
  avatarUrl:
    "https://cdn.faire.com/fastly/c60e95ba405057e3dbf9d93b7c041fab0568088a3246fe7d55fc3d4459ba2d52.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/16d0cef78793ef42416ef9390473cbccc24a3856dff24f7516b356362e471598.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c60e95ba405057e3dbf9d93b7c041fab0568088a3246fe7d55fc3d4459ba2d52.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/16d0cef78793ef42416ef9390473cbccc24a3856dff24f7516b356362e471598.jpeg",
  location: "Broken Bow, OK, USA",
  minimumOrderDollars: 103,
  rating: 5,
  reviewCount: 559,
  isTopShop: true,
  isInsider: true,
  description:
    "D&E Threads is proudly owned and operated by husband-and-wife team David and Emily in Southeast Oklahoma. What began in their garage in 2015 has grown into a nearly 4,000-square-foot production space dedicated to serving boutiques across the country.\n\nAs a family-run business, David and Emily stay closely involved in every step from design to production with a strong focus on quality, consistency, and styles that truly sell for retailers.\n\nD&E Threads is known for creating on-trend graphic apparel and embroidery pieces that are boutique-friendly, easy to merchandise, and designed with your customers in mind. Our goal is simple: to provide dependable bestsellers that help your shop succeed season after season.\n\nWe’re grateful to partner with retailers who value thoughtful design, reliable fulfillment, and a brand that grows alongside them.",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:44:59.458Z",
    importedBy: "entity-db-cli",
  },
};
